import moment from 'moment';

import './time-range.scss';

function isNextCalendarDayWithTime(date1: Date, date2: Date) {
	const startOfNextDay = moment(date1).add(1, 'day').startOf('day');
	return (
		moment(date2).isSameOrAfter(startOfNextDay) &&
		moment(date2).isBefore(moment(date1).add(2, 'days').startOf('day'))
	);
}

export interface TimeRangeProps {
	begin?: Date | null;
	end?: Date | null;
	className?: string;
	style?: Record<string, string>;
	disabled?: boolean;
	withMinutes?: boolean;
}

export const TimeRange: React.FC<TimeRangeProps> = ({
	begin,
	end,
	className = '',
	style,
	disabled,
	withMinutes = true,
}) => {
	const beginHours = begin ? moment(begin).format(withMinutes ? 'HH:mm' : 'HH') : '';
	const endHours = end ? moment(end).format(withMinutes ? 'HH:mm' : 'HH') : '';
	const nextDay = begin && end ? (isNextCalendarDayWithTime(begin, end) ? '(24)' : '') : '';

	return (
		<div className={`time-range ${className}`} style={style}>
			<input
				disabled={true}
				style={{ width: withMinutes ? '45px' : '27px' }}
				readOnly
				className={`input ${disabled ? 'disabled' : ''}`}
				value={beginHours}
			/>
			<input
				disabled={true}
				readOnly
				style={{ flexGrow: 1 }}
				className={`input ${disabled ? 'disabled' : ''}`}
				value={`${endHours}${nextDay}`}
			/>
		</div>
	);
};
